import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const InventoryOverviewPage = lazy(() =>
  import('../../pages/admin/inventory-overview/InventoryOverviewPage').then((m) => ({
    default: m.InventoryOverviewPage,
  })),
);

export const Route = createFileRoute('/admin/inventory-overview')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <InventoryOverviewPage />
    </Suspense>
  ),
});
